import React, { useState, useEffect } from 'react'
import Layout from '../../layouts/Layout'
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { getShippingMethodListAPI, getShippingZoneListAPI, updateShippingRateAPI, getShippingRateAPI } from '../../services/api/ShippingAPI';
import Swal from 'sweetalert2';
import { FaStarOfLife } from 'react-icons/fa';
import { useSelector } from "react-redux";
import { Link, useNavigate, useParams } from 'react-router-dom';
import Loader from '../components/Loader';

const EditShippingRate = () => {
    const { id } = useParams();
    const [loading, setLoading] = useState(false);
    const [shippingMethod, setShippingMethod] = useState([]);
    const [shippingZone, setShippingZone] = useState([]);
    const user = useSelector((state) => state.LoginReducer.authData);
    const token = user.data.token;
    const navigate = useNavigate();

    useEffect(() => {
        const fetchShippingMethodList = async () => {
            try {
                const data = await getShippingMethodListAPI(token);
                if (data.status) {
                    const options = data.data.map(item => ({
                        value: item.id,
                        label: item.name,
                    }));
                    setShippingMethod(options);
                }
            } catch (error) {
                console.error('Error fetching regions list:', error);
            } finally {
                setLoading(false);
            }
        };

        const fetchShippingZoneList = async () => {
            try {
                const data = await getShippingZoneListAPI(token);
                if (data.status) {
                    const options = data.data.map(item => ({
                        value: item.id,
                        label: item.name,
                    }));
                    setShippingZone(options);
                }
            } catch (error) {
                console.error('Error fetching regions list:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchShippingMethodList();
        fetchShippingZoneList();
    }, [token]);

    const validationSchema = Yup.object({
        rate_type: Yup.string()
            .required('Rate type is required'),
        shipping_zone: Yup.string()
            .required('Shipping zone is required'),
        shipping_method: Yup.string()
            .required('Shipping method is required'),
        from: Yup.string()
            .required('Rate from is required'),
        to: Yup.string()
            .required('Rate to is required'),
        rate: Yup.string()
            .required('Rate is required'),
    });

    const formik = useFormik({
        initialValues: {
            rate_type: '',
            shipping_zone: '',
            shipping_method: '',
            from:'',
            to: '',
            rate: ''
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            setLoading(true);
            const formData = new FormData();
            formData.append('rate_type', values.rate_type);
            formData.append('shipping_zone', values.shipping_zone);
            formData.append('shipping_method', values.shipping_method);
            formData.append('from', values.from);
            formData.append('to', values.to);
            formData.append('rate', values.rate);
            await updateShippingRate(formData);
        },
    });

    const updateShippingRate = async (formData) => {
        try {
            const data = await updateShippingRateAPI(formData, id, token);
            setLoading(false);
            if (data.status) {
                Swal.fire({
                    title: 'Shipping rate Updated!',
                    text: 'The Shipping rate has been Updated successfully.',
                    icon: 'success',
                    confirmButtonText: 'OK',
                }).then(() => {
                    navigate('/shippings');
                });
            }
        } catch (error) {
            setLoading(false);
            Swal.fire({
                title: 'Error!',
                text: 'Something went wrong please try again.',
                icon: 'error',
                confirmButtonText: 'OK',
            });
        }
    };

    useEffect(() => {
        const fetchShippingRate = async () => {
            try {
                const data = await getShippingRateAPI(id, token);                
                if (data === null) {
                    navigate('/404');
                } else {
                    formik.setValues({
                        rate_type: data.rate_type,
                        shipping_zone: data.shipping_zone_id,
                        shipping_method: data.shipping_method_id,
                        from: data.from,
                        to: data.to,
                        rate: data.rate
                    });
                }                  
                
            } catch (error) {
                Swal.fire({
                    title: 'Error!',
                    text: 'Could not fetch blog data.',
                    icon: 'error',
                    confirmButtonText: 'OK',
                });
            }
        };

        fetchShippingRate();
    }, [id]);

    if (loading) {
        return <Loader />;
    }
    return (
        <Layout title="Edit Shipping Rate">
            <div className="container table-container">
                <form onSubmit={formik.handleSubmit}>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-4 col-12">
                                <div className="form-group py-1 required">
                                    <label htmlFor="rate_type">Rate Type <FaStarOfLife className='text-danger' /></label>
                                    <select className="form-control mt-1" name='rate_type' id='rate_type' value={formik.values.rate_type} onChange={formik.handleChange} onBlur={formik.handleBlur}>
                                        <option value="">Select Option</option>
                                        <option value="Always">Always</option>
                                        <option value="Price">Price</option>
                                        <option value="Weight">Weight</option>
                                    </select>
                                </div>
                                {formik.touched.rate_type && formik.errors.rate_type ? (<label className="text-danger">{formik.errors.rate_type}</label>) : null}
                            </div>
                            <div className="col-md-4 col-12">
                                <div className="form-group py-1 required">
                                    <label htmlFor="shipping_method">Shipping Method <FaStarOfLife className='text-danger' /></label>
                                    <select className="form-control mt-1" name='shipping_method' id='shipping_method' value={formik.values.shipping_method} onChange={formik.handleChange} onBlur={formik.handleBlur}>
                                        <option value="">Select Option</option>
                                        {shippingMethod.map((method, index) => (
                                            <option key={index} value={method.value}>{method.label}</option>
                                        ))}
                                    </select>
                                </div>
                                {formik.touched.shipping_method && formik.errors.shipping_method ? (<label className="text-danger">{formik.errors.shipping_method}</label>) : null}
                            </div>
                            <div className="col-md-4 col-12">
                                <div className="form-group py-1 required">
                                    <label htmlFor="shipping_zone">Shipping Zone <FaStarOfLife className='text-danger' /></label>
                                    <select className="form-control mt-1" name='shipping_zone' id='shipping_zone' value={formik.values.shipping_zone} onChange={formik.handleChange} onBlur={formik.handleBlur}>
                                        <option value="">Select Option</option>
                                        {shippingZone.map((method, index) => (
                                            <option key={index} value={method.value}>{method.label}</option>
                                        ))}
                                    </select>
                                </div>
                                {formik.touched.shipping_zone && formik.errors.shipping_zone ? (<label className="text-danger">{formik.errors.shipping_zone}</label>) : null}
                            </div>
                            <div className="col-md-4 col-12">
                                <div className="form-group py-1 required">
                                    <label htmlFor="from">From <FaStarOfLife className='text-danger' /></label>
                                    <input type="text" className="form-control mt-1" name="from" id="from" placeholder="Enter from" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.from || ''} />
                                </div>
                                {formik.touched.from && formik.errors.from ? (<label className="text-danger">{formik.errors.from}</label>) : null}
                            </div>
                            <div className="col-md-4 col-12">
                                <div className="form-group py-1 required">
                                    <label htmlFor="to">To <FaStarOfLife className='text-danger' /></label>
                                    <input type="text" className="form-control mt-1" name="to" id="to" placeholder="Enter to" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.to || ''} />
                                </div>
                                {formik.touched.to && formik.errors.to ? (<label className="text-danger">{formik.errors.to}</label>) : null}
                            </div>
                            <div className="col-md-4 col-12">
                                <div className="form-group py-1 required">
                                    <label htmlFor="rate">Rate <FaStarOfLife className='text-danger' /></label>
                                    <input type="text" className="form-control mt-1" name="rate" id="rate" placeholder="Enter rate" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.rate || ''} />
                                </div>
                                {formik.touched.rate && formik.errors.rate ? (<label className="text-danger">{formik.errors.rate}</label>) : null}
                            </div>
                            <div className="row mt-3">
                                <div className="col-md-6 col-12 d-flex gap-3">
                                    <Link to={'/shippings'} type="submit" className="btn btn-dark cancel_btn">Cancel</Link>
                                    <button type="submit" className="btn btn-primary submit_btn">Submit</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </Layout>
    )
}

export default EditShippingRate